import { map, reduce } from 'lodash';
import { useSelector } from 'react-redux';

export default function useResourcesCount(source: any) {
  const branches = useSelector((state: any) => state.pipelines.branches);
  const flowNodes = useSelector((state: any) => state.entities.flowNodes);
  const branch = branches[source.nodeKey || source.origin_node_id];
  const branchItems = map(branch && branch.items, (nodeKey) => flowNodes[nodeKey]);
  const childrenCount = reduce(
    branchItems,
    (acc, thisItem, idx) => {
      if (thisItem.type === 'DATA_SET' && thisItem.dataSetType === 'derived') {
        acc.derivedDataSetsCount += 1;
      } else if (thisItem.type === 'DATA_SINK') {
        acc.sinksCount += 1;
      }
      return acc;
    },
    {
      derivedDataSetsCount: 0,
      sinksCount: 0,
    },
  );

  return {
    childrenCount,
    sourceDataSetsCount: source.children ? source.children.length : 0,
  };
}
